import React, { FC, memo } from 'react'
import './index.scss'

// props
interface IProps {
  /** 名称 */
  name: string;
  /** 已选择的名称 */
  choosedName: string;
  /** 是否展示 */
  isShow: boolean;
  /** 子元素 */
  children: React.ReactNode;
  /** 是否显示错误 */
  isWrong: boolean;
  /** 点击事件 */
  onClick: () => void;
}

const MultiChoose: FC<IProps> = ({ name, choosedName, isShow, children, isWrong, onClick }) => {
  return (
    <div className={`multi-choose-element${isShow ? ' show' : ''}${isWrong ? ' wrong' : ''}`} data-cypid='multi-choose-element' onClick={onClick}>
      <div className='title'>
        <span>{name}</span>
        <span className='choosed-name'>{choosedName}</span>
        <i className='iconfont icon-chevron-right'></i>
      </div>
      {
        React.Children.count(children) > 0 ? (
          <div className='to-choose'>
            <div className='selected-list'>{children}</div>
          </div>
        ) : null
      }
    </div>
  )
}

export default memo(MultiChoose)
